package us.laantech.laanmanage.feature.store.department

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.lifecycle.viewmodel.compose.viewModel
import androidx.lifecycle.viewmodel.initializer
import androidx.lifecycle.viewmodel.viewModelFactory
import us.laantech.common.dto.company.Department
import us.laantech.common.ui.DataTableView
import us.laantech.common.util.generateUUIDv7
import us.laantech.laanmanage.feature.scope.ParentCompanyScope


@Composable
fun StoreDepartmentsView(
    viewModel: StoreDepartmentsViewModel = viewModel(
        factory = viewModelFactory {
            initializer { StoreDepartmentsViewModel() }
        }
    )
) {
    val uiState by viewModel.uiState.collectAsStateWithLifecycle()
    LaunchedEffect(Unit) {
//        viewModel.loadDepartments(companyBranch)
    }

    ParentCompanyScope { _, companyBranch ->
        LaunchedEffect(companyBranch) {
            viewModel.loadDepartments(companyBranch)
        }

            Column(modifier = Modifier.fillMaxSize()) {

                //            RetailProductsListPreview(
//                modifier = Modifier.weight(1f),
//                uiState = uiState,
//            )

                Button({
                    viewModel.toggleCreateEditDepartmentModal()
                }) {
                    Text("Create New Department")
                }

                DataTableView<Department>(
                    modifier = Modifier.fillMaxSize().weight(2f),
                    rows = uiState.departments,
                ) {
                    column("Department Name", weight = 2f) {
                        Text(it.departmentName, modifier = Modifier.weight(2f))
                    }
//                column("Department UUID", weight = 2f) {
//                    Text(it.departmentUUID, modifier = Modifier.weight(2f))
//                },
                    column("Age Limit", weight = 1f) {
                        Text(it.ageLimit.toString(), modifier = Modifier.weight(1f))
                    }
                    column("Actions", weight = 1f) {
                        Button(onClick = { /* handle edit */ }, modifier = Modifier.weight(1f)) {
                            Text("Edit")
                        }
                    }
                }

            }

            if (uiState.showCreateEditDepartmentModal) {
                CreateNewDepartmentModal(viewModel)
            }

    }
}


@Composable
private fun CreateNewDepartmentModal(viewModel: StoreDepartmentsViewModel) {

    val deptUUID = generateUUIDv7()
    val deptNameTextFieldState = TextFieldState()
    val deptCode = TextFieldState()
    val deptMinAgeLimit = TextFieldState()


    AlertDialog(
        icon = {
//                Icon(Icons.Default.Menu, contentDescription = "Create Department")
        },
        title = { Text("Create New Department") },
        text = {
            Column {
                Text("Department UUID: $deptUUID")
                TextField(deptNameTextFieldState, label = { Text("Department Name") })

                TextField(deptCode, label = { Text("Department Code") })

                TextField(deptMinAgeLimit, label = { Text("Department Age Limit") })

            }
        },
        onDismissRequest = {
            viewModel.toggleCreateEditDepartmentModal()
        },
        confirmButton = {
            TextButton(
                onClick = {
                    // TODO move into uiState instead of passing in as function
                    viewModel.createDepartment(
                        deptUUID,
                        deptNameTextFieldState.text,
                        deptCode.text,
                        deptMinAgeLimit.text.toString().toIntOrNull() ?: 0
                    )
                }
            ) {
                Text("Confirm")
            }
        },
        dismissButton = {
            TextButton(
                onClick = {
                    viewModel.toggleCreateEditDepartmentModal()
                }
            ) {
                Text("Dismiss")
            }
        }
    )

}